import { FileType } from '@monorepo/interfaces';

export class LoadUploadLink {
    static readonly type = '[Data Upload] Get Upload Link';

    constructor(public fileType: FileType) {}
}

export class LoadCurrentUploads {
    static readonly type = '[Data Upload] Get Current Uploads';

    constructor(
        public fileType: FileType,
        public isInitial?: boolean
    ) {}
}

export class UploadFile {
    static readonly type = '[Data Upload] Upload File';

    constructor(
        public file: File,
        public uploadLink: string
    ) {}
}

export class AbortLatestUpload {
    static readonly type = '[Data Upload] Abort Upload';

    constructor(public fileType: FileType) {}
}

export class ConfirmFleetUpload {
    static readonly type = '[Data Upload] Confirm Fleet Upload';

    constructor(public uploadId: string) {}
}

export class CancelFleetUpload {
    static readonly type = '[Data Upload] Cancel Fleet Upload';

    constructor(public uploadId: string) {}
}
